<script setup lang="ts">
import { Modal } from '@arco-design/web-vue'
import dayjs from 'dayjs'
import { add } from 'lodash-es'
import QrcodeVue from 'qrcode.vue'
import Account from './Account.vue'
import PayModal from './PayModal.vue'
import { calculateDaysRemaining } from '~/utils/number'

const props = defineProps<{
  type: number
  resource: number
  visible: boolean
}>()
const emit = defineEmits(['ok'])
const { fetchTrades, cancelQueryIsPay, popoverVisible, userRole, tradeInfo, orderInfo, loading, curItem, totalAcount, curPrivilege, account, userCorporateMember, accountPrivileage } = usePay()

const user = useUser()
const payType = ref(props.type)
const isResource1 = computed(() => userRole.value?.resource === 1)
const isResource2 = computed(() => userRole.value?.resource === 2)
const filterPrivileges = computed(() => {
  return isResource1.value ? user.value.privileges?.filter(item => [1, 6].includes(item.resource)) : user.value.privileges?.filter(item => Number(item.resource) <= user.value?.info?.userRole && item.resource !== 3)
})
watch(() => props.resource, (val) => {
  curItem.value = filterPrivileges.value?.find((item: any) => item.resource === val) ?? filterPrivileges.value[0]
  curPrivilege.value = curItem.value?.privileges?.find((item: any) => item.month === payType.value) ?? curItem.value?.privileges[0]
  account.value = curItem.value?.resource === 6 ? 1 : 0
}, { immediate: true })

watch(() => [props.visible, curPrivilege.value, popoverVisible.value], () => {
  cancelQueryIsPay()
})
const localePath = useLocalePath()
const privileges = computed(() => {
  return curItem.value?.privileges?.filter((item: any) => [1, 12].includes(item.month))?.sort((a: any, b: any) => b.month - a.month)
})
function maskPhone(phone?: string) {
  return phone?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}
function openAccount() {
  const accountModal = Modal.open({
    width: 560,
    hideTitle: true,
    footer: false,
    skip: true,
    bodyStyle: { padding: '0' },
    content: () => h(Account, {
      onCancel: () => {
        accountModal.close()
      },
    }),
  })
}
const { refetchUserInfo } = useLogin()
function openModal(type: number) {
  const accountModal = Modal.open({
    width: 344,
    hideTitle: true,
    footer: false,
    skip: true,
    bodyStyle: { padding: '0' },
    content: () => h(PayModal, {
      type,
      data: curPrivilege.value,
      onCancel: () => {
        accountModal.close()
        if (type === 1) {
          emit('ok')
          refetchUserInfo()
        }
        else {
          fetchTrades()
        }
      },
    }),
    onCancel: () => {
      if (type === 1) {
        refetchUserInfo()
      }
    },
  })
}
watch(() => tradeInfo.value, (val) => {
  if (val?.status === 2) {
    openModal(1)
  }
  if (val?.status === 3) {
    openModal(2)
  }
  if (val?.status !== 0) {
    cancelQueryIsPay()
    // console.log('关闭弹窗,取消订单状态轮询')
  }
})
function onResourceChange(item: any) {
  curItem.value = item
  curPrivilege.value = item?.privileges[0]
  payType.value = item?.privileges[0]?.month
  account.value = item.resource === 6 ? 1 : userCorporateMember.value?.usedUserRelationCount
}
function onPrivilegeChange(item: any) {
  curPrivilege.value = item
  payType.value = item?.month
}
const updateTime = computed(() => {
  // 升级后剩余天数
  const remainDays = Number(userCorporateMember.value?.privilegeValueInDays)
  // 判断是续费还是升级
  const isSame = curItem.value?.resource === userRole.value?.resource
  const timestamp = isSame ? Number(userRole.value?.privilegeValue) * 1000 : dayjs().add(remainDays, 'day').valueOf()
  return dayjs(timestamp).add(Number(curPrivilege.value?.privilegeValue || payType.value * 30), 'day').format('YYYY/MM/DD')
})

const totalPrice = computed(() => {
  let _account = totalAcount.value
  let realPrice = curPrivilege.value?.realPrice
  const accountDayAvgPrice = accountPrivileage.value?.dayAvgPrice
  const resource = curItem.value?.resource || 1
  let privilegeValueInDays = 0

  if (resource === 6) {
    _account = account.value * (Number(userCorporateMember.value?.privilegeValueInDays) || 1)
    realPrice = 0
  }
  if (user.value.info?.userRole === 2) {
    privilegeValueInDays = Number(userCorporateMember.value?.privilegeValueInDays)
  }

  const result = add(realPrice, accountDayAvgPrice * _account * (curPrivilege.value?.privilegeValue + privilegeValueInDays))
  const decimalPlaces = result.toString().split('.')[1]?.length || 0
  if (decimalPlaces > 2) {
    return Math.ceil(result * 100) / 100
  }
  else {
    return result
  }
})
const { locale } = useI18n()
</script>

<template>
  <div v-if="filterPrivileges?.length" class="g-vip__dialog">
    <div class="g-vip__dialog--title h-160 w-full flex flex-col rd-t-8">
      <div class="relative box-border w-full flex flex flex-1 items-center items-center gap-8 px-24">
        <div class="box-border h-48 w-48 rd-full bg-white p-1">
          <a-avatar cursor-pointer class="h-full w-full bg-[--color-brand-6] text-20 font-600" image-url="">
            G
          </a-avatar>
        </div>
        <div flex flex-col justify-center gap-4>
          <div flex flex-1 items-center gap-8 text-white>
            <div class="w-fit text-16 font-600">
              {{ maskPhone(user.info?.phone) || user.info?.email }}
            </div>
            <div class="h-20 w-fit flex items-center rd-10 bg-[rgba(0,0,0,0.5)] px-8">
              <UserVipSign
                class="text-12 text-white !gap-4"
                iconClass="!w-16 !h-16"
              />
            </div>
          </div>
          <div class="text-12 text-#ffffff80">
            <span v-if="user.info?.userRole === 3">{{ $t('您当前为体验版，开通会员享更多权限') }}</span>
            <span v-else>
              {{ $t('有效期至') }} {{ dayjs(Number(userRole?.privilegeValue) * 1000).format(locale === 'en' ? 'YYYY/MM/DD' : 'YYYY年MM月DD日') }} <span v-if="calculateDaysRemaining(Number(userRole?.privilegeValue) * 1000) > 0">{{ $t('剩余') }}<span mx-2 text-white>{{ calculateDaysRemaining(Number(userRole?.privilegeValue) * 1000) }}</span>{{ $t('vip.days') }}</span></span>
          </div>
        </div>
        <span class="absolute right-24 top-30 h-20 w-20 flex cursor-pointer items-center justify-center text-16 text-white hover:op-80" @click="emit('ok')"><i class="icon-shanchu" /></span>
      </div>
      <div h-56 w-full flex gap-4>
        <div
          v-for="item in filterPrivileges"
          :key="item.resource"
          flex-1 rd-t-12
          :class="[{ 'active !text-[--color-text-1]': item.resource === curItem.resource }]"
          class="g-vip__dialog--tab flex cursor-pointer items-center justify-center gap-8 font-600"
          @click="onResourceChange(item)"
        >
          <UserVipSign :data="item" class="text-20 text-white" />
        </div>
      </div>
    </div>
    <div flex gap-20 p-24>
      <UserVipAside :data="curItem" />
      <div relative flex flex-1 flex-col gap-20>
        <div flex gap-20>
          <div
            v-for="item in privileges"
            :key="item.month"
            h-166 w-258 flex flex-col rd-12
            class="group relative cursor-pointer bg-[--color-fill-6]"
            :class="{ active: item.month === payType }"
            @click="onPrivilegeChange(item)"
          >
            <div flex-1 p-3 pb-0>
              <div h-full flex flex-col items-center justify-center rd-t-11 class="group-[.active]:bg-[--color-brand-1]">
                <div text-20 class="mt-4 text-[--color-text-1] font-500">
                  {{ item.month === 1 ? $t('月卡会员') : $t('年卡会员') }}
                </div>
                <div class="mt--8 flex items-baseline gap-4">
                  <span class="text-48 text-[--color-text-1] font-500"><span>￥</span><span ml--10 font-dinpro600>{{ item?.realPrice }}</span></span>
                  <!-- <div v-if="item?.discount < 10" relative box-border h-full flex items-end gap-4 pb-10>
                    <span class="text-14 text-[--color-text-3] font-600 lh-18 line-through">￥{{ item?.originalPrice }}&nbsp;</span>
                  </div> -->
                </div>
              </div>
            </div>
            <div h-34 class="g-vip__card--b rd-b-12 bg-[--color-fill-4] text-center font-600 lh-34">
              {{ $t('低至') }}{{ locale === 'en' ? ' ¥' : '' }}{{ item?.dayAvgPrice }}{{ locale === 'en' ? '' : '元' }}/{{ $t('天') }}
            </div>
            <!-- <span v-if="item?.discount < 10" absolute left-0 top--10 w-fit rd-12 rd-bl-0 rd-tl-8 px-16 color-white lh-24 ellipsis style="background: linear-gradient(95deg, #EC1DBC 1.69%, #A804C1 94.09%);">{{ $t('vip.discount', [locale === 'en' ? 100 - item?.discount * 10 : item?.discount]) }} 立减{{ item?.promotionInfo }}元</span> -->
          </div>
        </div>
        <div v-if="curItem.resource === 1">
          <div class="flex items-center gap-16 text-[--color-text-2] font-500">
            <div>
              {{ !isResource1 ? $t('升级后团队席位总数') : $t('续费后团队席位总数') }}：<span class="mx-2 text-[--color-brand-6] font-600">{{ userCorporateMember?.totalUserRelationCount }}</span>
            </div>
            <div>
              {{ $t('已用席位') }}：<span class="text-[--color-brand-6] font-600">{{ userCorporateMember?.usedUserRelationCount }}</span><span class="text-[--color-text-3] font-600">/{{ userCorporateMember?.totalUserRelationCount }}</span>
            </div>
            <NuxtLink v-if="isResource1" :to="localePath('/user/member')" target="_blank" class="cursor-pointer text-[--color-brand-6] font-400 hover:op-80" :hoverable="false">
              {{ $t('成员管理') }}
            </NuxtLink>
          </div>
          <div v-if="isResource2" class="mt-4 text-12 text-[--color-text-3]" v-html="$t('vip.proUpgradeTip', [`<span class='text-[--color-brand-6]'>${userCorporateMember?.privilegeValueInDays}</span>`, `<span class='text-[--color-brand-6]'>${Number(userCorporateMember?.privilegeValueInDays) + curPrivilege?.privilegeValue}</span>`])" />
        </div>
        <div mt-28 flex flex-col gap-20>
          <div v-if="(curItem.resource === 1 && user.info?.userRole === 3) || curItem.resource === 6" mt--28>
            <div class="flex items-center gap-4 text-16 text-[--color-text-1] font-600">
              {{ curItem.resource === 6 ? $t('新增子账号数量') : $t('子账号数量') }}
              <!-- <g-tooltip :title="$t('可前往【个人中心-成员管理】进行人员管理')">
                <img src="~/assets/images/user/vip/question.svg" alt="info" w-16>
              </g-tooltip> -->
            </div>
            <a-input-number
              v-model="account"
              :min="user.info?.userRole === 3 ? userCorporateMember?.usedUserRelationCount : 1"
              :style="{ 'width': '160px', '--color-fill-2': 'var(--color-fill-3)' }"
              placeholder="Please Enter"
              mode="button"
              :precision="0"
              :max="999"
              size="large"
              class="g-vip__account--btn mt-16 gap-8 text-center !bg-transparent"
            />
            <div v-if="curItem.resource === 6" class="mt-8 text-13 text-[--color-text-3]" v-html="$t('vip.subAccount', [`<span class='mx-2 text-[--color-brand-6]'>${userCorporateMember?.totalUserRelationCount}</span>`])" />
          </div>
          <div>
            <div class="flex items-center gap-4 text-16 text-[--color-text-1] font-600">
              {{ $t('支付方式') }}
            </div>
            <div mt-16 flex items-center gap-16>
              <a-button class="w-160 cursor-default text-14 font-500 !h-44 !rd-22 !text-[--color-text-1]" type="outline" shape="round">
                <img src="~assets/images/login/wechat.svg" mr-4 w-16>{{ $t('微信支付') }}
              </a-button>
              <span class="cursor-pointer text-[--color-brand-6] hover:op-80" @click="openAccount">{{ $t('对公账号') }}?</span>
            </div>
            <span class="mt-10 flex text-12 text-[--color-text-3]">
              <span>{{ $t('确认购买即表示您同意') }}Gloda</span>
              <NuxtLink :to="localePath('/privacy')" target="_blank" class="mx-4 cursor-pointer text-[--color-text-1] !text-12 hover:text-[--color-text-1] hover:underline" :hoverable="false">{{ $t('隐私条款') }}</NuxtLink>
            </span>
          </div>
        </div>
        <div absolute bottom-4 left-0 right-0 w-full flex items-end justify-between>
          <div class="flex flex-1 flex-col justify-end text-14px text-16 color-[--color-text-1]">
            <div flex items-baseline gap-4 font-600>
              {{ $t('vip.支付金额') }}
              <span class="color-#F56C6C">
                <span>￥</span><span class="text-36px font-dinpro600">{{ totalPrice }}</span>
              </span>
            </div>
            <div class="mt--4 text-12 text-[--color-text-3]">
              {{ $t('有效期至') }} {{ curItem.resource === 6 ? dayjs(Number(userRole?.privilegeValue) * 1000).format('YYYY/MM/DD') : updateTime }}
            </div>
          </div>
          <div v-if="curItem.resource === 6 && Number(userCorporateMember?.privilegeValueInDays) < 15" class="max-w-280 text-[--color-text-3]">
            {{ $t('当前账号临期不允许扩充') }}
          </div>
          <a-popover
            v-else v-model:popup-visible="popoverVisible"
            trigger="click"
            position="top" content-class="!p-12 !rd-8 !border-0"
          >
            <a-button class="active min-w-148 rd-27 text-20 font-600 !h-54 !text-white" :loading="loading" @click="fetchTrades()">
              {{ $t('确认购买') }}
            </a-button>
            <template v-if="orderInfo?.paymentInfo" #content>
              <div class="min-h-180 w-150 rd-8">
                <QrcodeVue :value="orderInfo?.paymentInfo" :size="152" />
                <div class="flex items-center justify-center gap-4 text-14 text-[--color-text-2]">
                  <img src="~assets/images/login/wechat.svg" w-16>{{ $t('请微信扫码支付') }}
                </div>
              </div>
            </template>
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.g-vip__dialog--title {
  background: url('~/assets/images/user/vip/dialog-bg.svg') center top/cover no-repeat;
}
.g-vip__dialog--tab{
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #522BBC;
  &.active {
    background: linear-gradient(180deg, rgba(82, 43, 188, 0.60) -55.37%, rgba(255, 255, 255, 0.00) 77.86%, rgba(255, 255, 255, 0.00) 116.96%), #FFF;
    > div {
      color: var(--color-text-1);
    }
  }
}
.g-vip__account--btn {
  --color-secondary: var(--color-fill-2);
  :deep(.arco-input-prepend),
  :deep(.arco-input-append) {
    @apply "!rd-full !bg-none !border-none ";
  }
  :deep(.arco-btn-secondary) {
    @apply "!bg-none !rd-full !border-none !text-[--color-text-3]";
  }
  :deep(.arco-input-wrapper) {
    @apply "!rd-4";
    input {
      @apply "!text-center";
    }
  }
}
.active {
  background: linear-gradient(96deg, #924EF9 9.08%, #671BF8 92.76%);
  .g-vip__card--b {
    background: linear-gradient(96deg, #924EF9 9.08%, #671BF8 92.76%);
    color: #FFF
  }
}
</style>
